const params = [{ programs: "Architecture", value: "ARCH" }];

export default params;
